import { Link } from 'react-router-dom';
import { getRoomVisitCounts } from '@/hooks/useRoomVisit';
import { rooms } from '@/data/rooms';
import { useLanguage } from '@/i18n/LanguageContext';
import { TrendingUp } from 'lucide-react';

const TopRooms = () => {
  const { t } = useLanguage();
  const visits = getRoomVisitCounts();

  const topRooms = Object.entries(visits)
    .map(([id, count]) => {
      const room = rooms.find((r) => r.id === id);
      return room ? { ...room, count: count as number } : null;
    })
    .filter(Boolean)
    .sort((a, b) => b!.count - a!.count)
    .slice(0, 3) as Array<(typeof rooms)[0] & { count: number }>;

  if (topRooms.length === 0) return null;

  return (
    <div className="space-y-3">
      <h3 className="text-[10px] uppercase tracking-widest text-muted-foreground/30 flex items-center gap-2">
        <span className="w-1 h-1 rounded-full bg-muted-foreground/20" />
        <TrendingUp className="w-3 h-3" />
        {t('top_rooms') || 'Your Top Rooms'}
      </h3>
      <div className="grid grid-cols-3 gap-3">
        {topRooms.map((room) => (
          <Link
            key={room.id}
            to={room.path}
            className="p-3 border border-border/20 rounded-xl hover:border-foreground/20 transition-all hover:-translate-y-0.5 group"
          >
            <p className="text-xs font-light truncate group-hover:text-foreground transition-colors">
              {t(`room_${room.id}`) !== `room_${room.id}` ? t(`room_${room.id}`) : room.title}
            </p>
            <p className="text-[10px] text-muted-foreground/30 mt-1">
              {room.count} {t('visits_count') || 'visits'}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TopRooms;
